"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = randomId;

var _mathRandom = _interopRequireDefault(require("math-random"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */


function randomId() {
  var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  return (0, _mathRandom.default)().toString(36).substr(2, maxLength);
}